import { Box, Grid, List, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { GeneralSetup } from "./../../../../../components/GeneralSetup/GeneralSetup";
import { useLocation, useNavigate } from "react-router-dom";
import ManageInboundSettingsRouter from "../../../../../router/ManageInboundSettingsRouter";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";

export default function ManageInboundSettingsRoot(props: any) {
  const { registrationStep, activeInstitute } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();

  const userFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );
  const { userById } = useSelector((state: any) => state.userDetails);

  const [isActive, setIsActive] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  function handleGoBack() {
    if (window.location.href.includes("Email")) {
      navigate("/app/inbound/Email");
    } else if (window.location.href.includes("ImportSetting")) {
      navigate("/app/inbound/Contacts");
    } else if (window.location.href.includes("Import")) {
      navigate("/app/inbound/Import");
    }
  }

  useEffect(() => {
    if (window.location.href.includes("Email")) {
      setIsActive(0);
    } else if (window.location.href.includes("Import")) {
      setIsActive(1);
    } else {
      setIsActive(0);
    }

    // if (location?.state?.menuItemNumber && location?.state?.menuItemNumber) {
    //   setIsActive(location?.state?.menuItemNumber);
    // } else if (location?.state) {
    //   setIsActive(location?.state);
    // }
  }, [setIsActive, location]);

  const handleStatus = React.useCallback(
    (index: number) => {
      setIsActive(index);
    },
    [setIsActive]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (
      userFromLocalStorage &&
      userFromLocalStorage.isProfileCompleted === false
    ) {
      setButtonDisabled(true);
    }
  }, [setButtonDisabled, userFromLocalStorage]);

  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const accountStatus = instituteData?.billingStatus;
  const shouldDisableGeneralSetup =
    accountStatus === "ARCHIVED" ||
    accountStatus === "LOCKED" ||
    accountStatus === "UNARCHIVED" ||
    accountStatus === "INACTIVE";

  return (
    <Box
      sx={{ flexGrow: 1 }}
      style={{
        overflow: "auto",
        padding: "14px 16px",
        background: "#EEEEEE",
        maxHeight: "calc(100vh - 65px)",
        position: "relative",
      }}
    >
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          overflow: "hidden",
          background: "#fff",
          border: "1px solid #E9E9E9",
          borderRadius: "8px",
          minHeight: "calc(100vh - 94px)",
        }}
        id="manage"
      >
        <Box>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}
          >
            <Grid
              item
              xs={12}
              md={3}
              sm={9}
              lg={2.2}
              xl={2}
              sx={{
                maxHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: !userFromLocalStorage.isProfileCompleted
                    ? "calc(100vh - 208px)"
                    : "calc(100vh - 94px)",
                  md: !userFromLocalStorage.isProfileCompleted
                    ? "calc(100vh - 208px)"
                    : "calc(100vh - 94px)",
                },
                minHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
                overflowY: "auto",
                borderRight: "1px solid #c7c7c7",
              }}
            >
              <Box>
                <button
                  className="PageBackBtn"
                  style={{
                    marginTop: "20px",
                    paddingLeft: "34px",
                    paddingRight: "45px",
                  }}
                  onClick={handleGoBack}
                >
                  <ArrowBackIcon
                    sx={{
                      marginRight: "8px",
                      fontSize: "15PX",
                      color: "#667085",
                    }}
                  />
                  Back
                </button>
                <Typography
                  variant="h3"
                  sx={{
                    paddingLeft: "34px",
                    fontSize: "18px",
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontWeight: "500",
                    paddingRight: "45px",
                  }}
                >
                  Settings
                </Typography>
                <Box
                  sx={{
                    width: { xs: "95vw", sm: 550, lg: "auto", md: "auto" },
                    height: {
                      lg: "auto",
                    },
                    overflowY: {
                      xs: "scroll",
                      lg: "hidden",
                      md: "scroll",
                      sm: "scroll",
                    },
                    paddingLeft: "20px",
                    paddingRight: "30px",
                  }}
                >
                  <List
                    sx={{
                      fontSize: { xs: 2 },

                      display: {
                        xs: "-webkit-box",
                        sm: "flex",
                        md: "block",
                        lg: "block",
                      },
                      alignItems: {
                        xs: "center",
                        sm: "center",
                        md: "flex-start",
                        lg: "flex-start",
                      },
                      overflowY: {
                        xs: "scroll",
                        lg: "hidden",
                      },
                      padding: { xs: 0 },
                      pointerEvents: buttonDisabled ? "none" : "auto",
                      ".MuiTypography-root": {
                        fontSize: "0.8rem !important",
                      },
                    }}
                  >
                    {[
                      {
                        sectionName: "Email Integration",
                        allAccess: getSubDomainAccessStatus(
                          "INBOUND",
                          "EMAIL",
                          "ALL_ACCESS",
                          userById?.rolePermission
                        ),
                      },

                      {
                        sectionName: "Import",
                        allAccess: getSubDomainAccessStatus(
                          "INBOUND",
                          "IMPORT",
                          "ALL_ACCESS",
                          userById?.rolePermission
                        ),
                      },
                    ]
                      .filter((item) => item !== null)
                      .map((item, index) => (
                        <GeneralSetup
                          key={index}
                          handleStatus={handleStatus}
                          index={index}
                          isActive={isActive}
                          item={item?.sectionName}
                          itemAllAccess={item?.allAccess}
                        />
                      ))}
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
              sm={6}
              lg={9.8}
              xl={10}
              style={{
                paddingLeft: "0px",
                paddingRight: "15px",
                padding: !userFromLocalStorage.isProfileCompleted ? "" : "0px ",
                overflow: "auto",
                overflowX: "hidden",
              }}
              sx={{
                maxHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
                minHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
              }}
            >
              <ManageInboundSettingsRouter
                setIsActive={setIsActive}
                shouldDisableGeneralSetup={shouldDisableGeneralSetup}
                isActive={isActive}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
